module.exports = __webpack_public_path__ + "img/palm4.b1a5cf49.png";